<script>
import { createNamespacedHelpers } from 'vuex';
import { ScButton } from '@intelipost-js/secure-components';
import { Lodash } from '@intelipost-js/secure-providers';
import NewPageBase from '../../../../components/new-page-base/NewPageBase.vue';
import BillingFilterArea from '../../components/billing-filter-area/BillingFilterArea.vue';
import BillingsTotalizers from '../../components/billings-totalizers/BillingsTotalizers.vue';
import SingleBillingDetail from './components/single-billing-detail/SingleBillingDetail.vue';

const { mapState, mapActions } = createNamespacedHelpers('recon/billing');

export default {
  name: 'PageLPBillingsDetail',
  data() {
    return {
      logisticProviderId: this.$route.params.id,
    };
  },
  methods: {
    ...mapActions(['loadBillingTotalizers', 'loadBillingDetails']),
    refreshValues({ dateRange, dateSource, warehouseFilter }) {
      const args = {
        dateRange: dateRange || this.selectedDateRange,
        dateSource,
        logisticProviderId: this.logisticProviderId,
        warehouseIds: warehouseFilter,
      };

      this.loadBillingTotalizers(args);
      this.loadBillingDetails(args);
    },
  },
  computed: {
    ...mapState(['totalizers', 'loadingBillingDetails', 'logisticProviderBillingDetails']),
    logisticProviderName() {
      return this.$store.getters['logisticProviders/logisticProviderName'](this.logisticProviderId);
    },
    logisticProviderLogo() {
      const { S3_ASSETS_URL } = process.env || {};
      return `${S3_ASSETS_URL}images/logistic_provider/${this.logisticProviderId}.png`;
    },
  },
  async created() {
    if (Lodash.isEmpty(this.$store.getters['logisticProviders/allDeliveryMethods'])) {
      await this.$store.dispatch('logisticProviders/getLogisticProviders');
    }

    if (Lodash.isEmpty(this.$store.state.warehousesDropdown.warehouses)) {
      await this.$store.dispatch('warehousesDropdown/getWarehouses');
    }
  },
  components: {
    ScButton,
    NewPageBase,
    BillingFilterArea,
    BillingsTotalizers,
    SingleBillingDetail,
  },
};
</script>

<template>
  <new-page-base
    @back="$router.push({ name: 'billing-main-page' })"
    showBackText="Faturas">

    <template slot="titleLeft">
      <img
        :src="logisticProviderLogo"
        :alt="logisticProviderName"
        class="logistic-provider-logo" />
    </template>

    <section class="page-content">
      <billing-filter-area @onFilterChange="refreshValues"/>
      <billings-totalizers :totalizers="totalizers"/>
      <section class="page-content__details" v-if="!loadingBillingDetails">
        <single-billing-detail
          v-for="(billing, k) in logisticProviderBillingDetails"
          :key="k"
          :detail="billing"
        />
      </section>
    </section>
  </new-page-base>
</template>

<style scoped lang="scss">
.logistic-provider-logo {
  width: 120px;
  margin-top: .5em;
}

.page-content {
  &__details {
    margin-top: 1.5em;

    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/detail/PageLPBillingsDetail.vue?4fc7d489